export default {
  coffeeData: {
    windBreaker: "Árvore quebra-vento",
    horticultureInfo: "Árvore de horticultura",
    shadeTree: "Árvore de sombra",
    coffeeVariety: "Variedade de café",
    coffeeSpecies: "Espécies de café",
    coffeeCherryQuality: "Qualidade da Cereja de Café",
    processingBatchQuality: "Qualidade do Lote de Processamento",
    greenCoffeeQuality: "Qualidade de Café Verde",
    processType: "Tipo de Processo",
    updateWindBreaker: "Atualizar tipo de árvore quebra-vento",
    addWindBreaker: "Adicionar novo tipo de árvore quebra vento",
    updateHorticultureInfo:
      "Atualizar informações de tipo de árvore na horticultura",
    addHorticultureInfo:
      "Adicionar novas informações de tipo de árvore na horticultura",
    updateShadeTree: "Atualizar tipo de árvore de sombra",
    addShadeTree: "Adicionar novo tipo de árvore para sombra",
    updateCoffeeVariety: "Atualizar tipo de árvore coffeeVariety",
    addCoffeeVariety: "Adicione o novo tipo de árvore à variedade de café",
    deleteVarietyTitle: "Excluir variedade",
    deleteVarietyMessage: "Tem certeza de que deseja excluir a variedade?",
    updateCoffeeSpecie: "Atualizar espécie de café",
    deleteSpecieTitle: "Excluir espécie",
    deleteSpecieMessage: "Tem certeza de que deseja excluir Espécie?",
    addCoffeeSpecie: "Adicionar nova espécie de café",
    variety: "Variedade",
    selectVariety: "Selecionar variedade",
    selectSpecie: "Selecionar espécie",
    deleteCoffeeRecord: "Tem certeza de que deseja excluir o registro?",
    deleteCoffeeData: "Excluir dados de café",
    topicRequired: "O nome do tópico é obrigatório",
    coffeeAddSuccess: "Espécie de café adicionada com sucesso.",
    treeTypeSuccess: "Tipo de árvore adicionado com sucesso..",
    treeTypeUpdateSuccess: "Tipo de árvore atualizado com sucesso.",
    coffeeVarietySuccess: "Variedade de café adicionada com sucesso.",
    coffeeSpecieSuccess: "Espécie de café atualizada com sucesso.",
    nameRequired: "O nome é obrigatório",
    notFound: "Nenhum dado do Admin encontrado.",
  },
  cacaoData: {
    cacao: "Cacau",
    cacaoOverview: "Visão Geral do Cacau",
    cacaoVariety: "Variedade de Cacau",
    cacaoSpecies: "Espécie de Cacau",
    deleteCacaoData: "Excluir Dados de Cacau",
    cacaoWeight: "Peso do Cacau",
    cacaoType: "Tipo de Cacau",
    productWeight: "Peso do Produto",
    productType: "Tipo de Produto",
    productPricePerKg: "Preço por KG",
    registerFermentation: "Registrar Fermentação",
    batchVisualIdentification: "Identificação Visual do Lote",
    initialWeight: "Peso Inicial",
    finalWeight: "Peso Final",
    performance: "Desempenho",
    fermentationPercentage: "Porcentagem de Fermentação",
    fermetationMethod: "Método de Fermentação",
    boxes: "Caixas",
    piles: "Pilhas",
    bags: "Sacos",
    selectZone: "Selecionar Zona",
    selectPlantation: "Selecionar Plantação",
    deliveryMethod: "Método de Entrega",
    totalPrice: "Preço Total",
  },
  memberDataSection: {
    import: "Importar",
    buyingStation: "Estação de Compra",
    factory: "Fábrica",
    factories: "Fábricas",
    societies: "Sociedades",
    factoriesName: "Nome da Fábrica",
    factoriesProdChart: "Gráfico de Produção de Fábricas",
    factoryInfo: "Informações da Fábrica",
    factoryDashboard: "Painel da Fábrica",
    factoryDashboardPage: {
      title: "Painel da Fábrica",
      close: "Fechar",
      resetFilters: "Redefinir Filtros",
      apply: "Aplicar",
      monthlySupplyTrend: "Tendência Mensal de Fornecimento",
      processingEfficiency: "Eficiência de Processamento",
      funnelChart: "Gráfico de Funil - Entrada -> Saída",
      totalLoss: "Perda Total",
      noTarget: "Nenhuma meta definida",
      ytdScope: "(Acum. {year})",
      operationalEfficiency: "Eficiência Operacional",
      target: "Meta",
      actual: "Real",
      farmerParticipation: "Participação dos Agricultores - Distribuição de Contribuição",
      totalInput: "Entrada Total",
      totalOutput: "Saída Total",
      activeFarmers: "Agricultores Ativos",
      rawIntake: "Entrada Bruta (Cereja Recebida)",
      processing: "Processamento (Cereja Processada)",
      output: "Saída (Pergaminho Produzido)",
      currentPeriod: "Período Atual",
      previousPeriod: "Período Anterior",
      volumePerTopFarmers: "Volume por Principais Agricultores",
      cumulativeImpact: "Impacto Cumulativo (%)",
      deliveries: "Entregas (kg)",
      operational: "Operacional",
      volume: "Volume (kg)",
      cumulative: "Cumulativo (%)",
      to: "até",
      ranges: {
        today: "Hoje",
        week: "Semana",
        month: "Mês",
        year: "Ano",
        all: "Todos",
      },
    },
    continue: "Continuar",
    farmerId: "ID do Agricultor",
    farmerName: "Nome do Agricultor",
    farmerAddress: "Endereço do Agricultor",
    quality: "Qualidade",
    quantity: "Quantidade",
    importAll: "Importar Tudo",
    importSelected: "Importar Selecionado",
    fileLoaded: "Arquivo carregado com sucesso",
    incorrectHeaders: "Cabeçalhos incorretos",
    processingBatch: "Processando Lote",
    purchaseOrder: "Ordem de Compra",
    buyingStationDetails: "Detalhes do Posto de Compra",
    buyingStationUsers: "Usuários do Posto de Compra",
    activityLog: "Registro de Atividade",
    startDate: "Data de Início",
    endDate: "Data de Término",
    selectCrop: "Selecionar Cultura",
    purchasingOrder: "Ordem de Compra",
    totalCoffeeCherry: "Total de Café Cereja",
    airHumidity: "Umidade do Ar",
    density: "Densidade",
    temperature: "Temperatura",
    beanMoistureContent: "Conteúdo de Umidade do Feijão",
    processType: "Tipo de Processo",
    batchRating: "Selecione a Classificação do Lote",
    purchaseDate: "Data de Compra",
    selectFarmer: "Selecionar Agricultor",
    selectFarm: "Selecionar Fazenda",
    selectPlantation: "Selecionar Plantação",
    coffeeVariety: "Variedade de Café",
    coffeeSpecies: "Espécie de Café",
    coffeeCherryQuantity: "Quantidade de Café Cereja",
    coffeeCherryQuality: "Qualidade do Café Cereja",
    coffeeType: "Tipo de Café",
    pricePerKg: "Preço Por Kg",
    processingDone: "Processamento Concluído",
    processedCoffeeOut: "Café Processado",
    farmer: "Agricultor",
    farm: "Fazenda",
    plantation: "Plantação",

    // Recently added
    farmers: "Agricultores",
    farmLimitUsed: "Limite de Fazenda Usado",
    phoneNumber: "Número de Telefone",
    farmSize: "Tamanho da Fazenda",
    farmLocation: "Fazenda/Localização",
    date: "Data",
    status: "Status",
    noFarmers: "Nenhum Agricultor Encontrado",
    approveReject: "Aprovar/Rejeitar",
    farms: "Fazendas",
    crops: "Culturas",
    equipment: "Equipamento",
    noFarms: "Nenhuma Fazenda Encontrada",
    views: "Visualizar",
    selectStatus: "Selecionar Status",
    approved: "Aprovado",
    rejected: "Rejeitado",
    reject: "Rejeitar",
    approve: "Aprovar",
    cancel: "Cancelar",
    add: "Adicionar",
    describeYourReason: "Descreva sua razão aqui",
    userInformation: "Informações do Usuário",
    userFarmRequest: "Solicitação de Fazenda do Usuário",
    userFarmInformation: "Informações da(s) Fazenda(s) do Usuário",
    activity: "Atividade",
    activityType: "Tipo de Atividade",
    farmZone: "Zona da Fazenda",
    farmerView: "Visualização do Agricultor",
    cropType: "Tipo de Cultura",
    cropVarity: "Variedade da Cultura",
    area: "Área",
    cost: "Custo",
    geofence: "Geofence",
    map_views: "Visualização no Mapa",
    viewAllFarms: "Visualizar Todas as Fazendas",
    farmersDetails: "Detalhes do Agricultor",
    download: "Baixar",
    pOrder: {
      addNew: "Adicionar Novo",
      viewAll: "Visualizar Todos",
      selectDate: "Selecionar data",
      makeSelection: "Fazer uma seleção",
      coffeeType: "Tipo de café quantidade",
      enterPrice: "Digite o Preço",
      reqPurchaseDate: "A data de compra é obrigatória",
      reqFarmer: "O agricultor é obrigatório",
      reqCoffeeQnty: "Quantidade de Café Cereja é obrigatória",
      reqPrice: "O Preço Por Kg é obrigatório",
      grandTotal: "TOTAL GERAL",
      selectDateRange: "Selecionar Intervalo de Datas",
      import: "Importar",
      purchaseId: "ID de Compra",
      purchaseDate: "Data de Compra",
      farmerName: "Nome do Agricultor",
      quality: "Qualidade",
      quantity: "Quantidade",
      pricePerKg: "Preço Por Kg",
      selectBuyingStation: "Selecionar estação de compra",
      searchUser: "Pesquisar Usuários",
    },
    farmActivity: "Atividade da Fazenda",
    showOnMap: "Mostrar no Mapa",
    farmInformation: "Informações da Fazenda",
    dateOfEntry: "Data de Entrada",
    farmID: "ID da Fazenda",
    ownershipType: "Tipo de Propriedade",
    locationAddress: "Endereço da Localização",
    goalType: "Tipo de Meta",
    totalSize: "Tamanho Total",
    zones: "Zonas",
    farmActivities: "Atividades da Fazenda",
    farmDetails: "Detalhes da Fazenda",
    totalFarmsRegistered: "Total de Fazendas Registradas",
    totalFarmArea: "Área Total da Fazenda",
    totalZone: "Total de Zonas",
    zone: "Zona",

    totalCost: "Custo Total",
    selectFarmZone: "Selecionar Zona/Fazenda",
    productionType: "Tipo de Produção",
    certifications: "Certificações",
    geofences: "Geofences",
    farmsChart: "Gráfico de Fazendas",
    
    
    // Buying Station specific translations
    buyingStations: "Estações de Compra",
    registerBuyingStation: "Registrar Estação de Compra",
    registerFactory: "Registrar Fábrica",
    loadingFactory: "Carregando Fábrica...",
    loadingBuyingStation: "Carregando Estação de Compra...",
    searchBuyingStation: "Pesquisar Estação de Compra",
    searchFactory: "Pesquisar Fábrica",
    searchSociety: "Pesquisar Sociedade",
    nameAndId: "Nome / ID",
    email: "E-mail",
    mobileNumber: "Número de Celular",
    role: "Função",
    actions: "Ações",
    view: "Visualizar",
    edit: "Editar",
    activate: "Ativar",
    deactivate: "Desativar",
    operator: "Operador",
    supplier: "Fornecedor",
    active: "Ativo",
    deactivated: "Desativado",
    activatedSuccessfully: "Estação de compra ativada com sucesso",
    deactivatedSuccessfully: "Estação de compra desativada com sucesso",
  
    factoryActivatedSuccessfully: "Fábrica ativada com sucesso",
    factoryDeactivatedSuccessfully: "Fábrica desativada com sucesso",
    factoryRegisteredSuccessfully: "Fábrica registrada com sucesso",
    
    // Buying Station Details specific translations
    userDetails: "Detalhes do Usuário",
    name: "Nome",
    provinceState: "Província/Estado",
    villageCityTown: "Vila/Cidade/Município",
    country: "País",
    associatedFarms: "Fazendas Associadas",
    back: "Voltar",
    addPurchaseOrder: "Adicionar Ordem de Compra",
    cherryCollection: "Coleta de Cereja",
    addCherryCollection: "Adicionar Coleta de Cereja",
    search: "Pesquisar",
    orderId: "ID do Pedido",
    farmFarmer: "Fazenda / Agricultor",
    coffeeSpeciesVariety: "Espécie / Variedade de Café",
    quantityPrice: "Quantidade / Preço",
    delete: "Excluir",
    
    // Processing Batch specific translations
    addProcessingBatch: "Adicionar Lote de Processamento",
    batchId: "ID do Lote",
    lots: "Lotes",
    greenCoffeeOut: "Café Verde Saída",
    startEndDate: "Data de Início/Data de Término",
    
    // Associated Farms specific translations
    addFarm: "Adicionar Fazenda",
    farmNameAndId: "Nome e ID da Fazenda",
    addressOfProduction: "Endereço de Produção",
    areaHa: "Área (ha)",
    type: "Tipo",
    eudrDeforestationStatus: "Status de Desmatamento EUDR",
    eudrDeforestationStatusTT: "Status de Avaliação de Risco de Desmatamento EUDR",
    zeroNegligibleProbability: "Probabilidade Zero/Desprezível",
    assessments: "Avaliações",
    riskAssessment: "Avaliação de Risco",
    compliant: "Conforme",
    nonCompliant: "Não Conforme",
    pending: "Pendente",
    dateOfSubmission: "Data de Submissão",
    dateOfExpiry: "Data de Validade",
    selectFarms: "Selecionar Fazendas",
    reviewSelection: "Revisar Seleção",
    next: "Próximo",
    reviewMappingPrompt: "Você selecionou {count} fazenda(s). Confirme para mapeá-las para esta Fábrica.",
    confirmMapping: "Confirmar Mapeamento",
    farmsMappedSuccess: "Fazendas mapeadas com sucesso",
    farmsMappedError: "Falha ao mapear fazendas",
    owner: "Proprietário",

    buyingStationOrder: {
      bulkImport: {
        importBulkData: "Importar Dados em Massa",
        importButton: "Importar Ordens de Compra em Massa",
        title: "Importação em Massa de Dados de Ordens de Compra",
        // Upload tab
        templateNote: "Baixe e use os modelos abaixo para importar ordens de compra em massa.",
        selectTemplate: "Selecionar Modelo",
        templateXls: "Importar Formato XLS",
        downloadXls: "Baixar Formato XLS",
        selectFile: "Selecione o arquivo para Carregar os Dados",
        dropHere: "ou arraste e solte aqui",
        fileUploaded: "O arquivo foi carregado com sucesso.",
        importantNote: "Nota Importante",
        importantNoteDetail:
          "Use os modelos fornecidos acima para os carregamentos em massa. Outros formatos resultarão em falha.",
        unsupportedFileFormat: "Este formato de arquivo não é suportado.",
        invalidFileFormat: "Carregue um arquivo .xlsx, .xls ou .csv válido usando o modelo fornecido.",
        templateErrorIntro:
          "O arquivo enviado não corresponde ao modelo necessário. Baixe o modelo e tente novamente.",
        importingTitle: "Importando...",
        importingNote:
          "Os arquivos enviados estão sendo processados no momento.\nNotificaremos você assim que os arquivos forem carregados com sucesso.",
        // Result page
        importCompleted: "Importação Concluída",
        recordsReadyToImport: "registros prontos para importar",
        tabTotalRecords: "Total de Registros",
        tabSuccess: "Sucesso",
        tabIssues: "Problemas",
        filterAll: "Todos",
        filterSuccess: "Sucesso",
        issuesDetected: "Problemas Detectados",
        issuesDetectedHeading: "Discrepância detectada:",
        issuesDetectedDescription:
          "Algumas linhas têm problemas de dados (por ex., data de compra inválida, agricultor, fazenda ou dados de café desconhecidos). Revise e resolva-os antes do envio final.",
        deleteRowsWithIssues: "Excluir linhas com Discrepâncias de Dados",
        // Table headers
        purchaseDate: "Data de Compra",
        farmer: "Agricultor",
        farm: "Fazenda",
        buyingStation: "Estação de Compra",
        coffeeQuantityQuality: "Quantidade e Qualidade do Café",
        plantation: "Plantação",
        coffeeSpecies: "Espécie de Café",
        coffeeVariety: "Variedade de Café",
        coffeeType: "Tipo de Café",
        coffeeCherryQuantity: "Quantidade de Café Cereja",
        coffeeCherryQuality: "Qualidade do Café Cereja",
        pricePerKg: "Preço Por Kg",
        receiptNo: "Número do Recibo",
        lotId: "ID do Lote",
        photos: "Fotos",
        // Actions / dialogs
        purchaseOrder: "Ordem de Compra",
        detailsTitle: "Detalhe da Ordem de Compra",
        editRecord: "Editar registro",
        deleteRecord: "Excluir registro",
        deleteRecordConfirm:
          "Tem certeza de que deseja excluir este registro? Esta ação não pode ser desfeita.",
        deleteDiscrepancyConfirm:
          "Tem certeza de que deseja excluir todas as {count} linha(s) com problemas? Esta ação não pode ser desfeita.",
        cancelImportTitle: "Cancelar Importação",
        cancelImportConfirm:
          "Tem certeza de que deseja cancelar esta importação? Os registros validados não poderão mais ser importados.",
        cancelImportConfirmBtn: "Cancelar Importação",
        importConfirm: "Importar {count} registro(s) válido(s) agora?",
        recordUpdatedSuccess: "Registro atualizado com sucesso.",
        recordsDeletedSuccess: "Registros excluídos com sucesso.",
        importCancelledSuccess: "Importação cancelada com sucesso.",
        genericError: "Algo deu errado. Tente novamente.",
        noDataFound: "Nenhum dado encontrado.",
        // Edit dialog
        selectFactory: "Selecionar fábrica",
        selectFarmer: "Selecionar Agricultor",
        selectFarm: "Selecionar Fazenda",
        selectPlantation: "Selecionar Plantação",
        submit: "Enviar",
        addImage: "Adicionar Imagem",
        addedBy: "Adicionado por",
        close: "Fechar",
        // Success dialog
        successDialogTitle: "Mensagem de Sucesso",
        importedSuccessfully: "{count} ordem(ns) de compra foram importadas com sucesso.",
        // History
        historyFile: "Nome do Arquivo",
        historyImportedOn: "Importado Em",
        historyEmpty: "Ainda não há histórico de importação em massa.",
        statusValidating: "Validando",
        statusSuccess: "Importado",
        statusCancelled: "Cancelado",
        // Error-code labels (tooltips / field messages)
        errorInvalidPurchaseDate: "A data de compra é inválida.",
        errorMissingPurchaseDate: "A data de compra está ausente.",
        errorMissingMemberId: "O ID do membro está ausente.",
        errorInvalidMemberIdFormat: "O formato do ID do membro é inválido. Esperado: Nome do agricultor - Nome da estação de compra - ID da fazenda.",
        errorInvalidFarmerName: "O agricultor não foi encontrado na sua organização.",
        errorInvalidBuyingStationName: "A estação de compra não foi encontrada na sua organização.",
        errorInvalidFarm: "A fazenda não foi encontrada na sua organização.",
        errorMissingQuantity: "A quantidade de café cereja está ausente.",
        errorInvalidQuantity: "A quantidade de café cereja deve ser um número maior que zero.",
        errorMissingQuality: "A qualidade do café cereja está ausente.",
        errorInvalidQuality: "A qualidade do café cereja não foi reconhecida.",
        errorMissingPrice: "O preço está ausente.",
        errorInvalidPrice: "O preço deve ser um número válido.",
        // Filter chip short labels
        chipInvalidPurchaseDate: "Data de Compra Inválida",
        chipMissingPurchaseDate: "Data de Compra Ausente",
        chipMissingMemberId: "ID do Membro Ausente",
        chipInvalidMemberIdFormat: "Formato de ID do Membro Inválido",
        chipInvalidFarmerName: "Agricultor Inválido",
        chipInvalidBuyingStationName: "Estação de Compra Inválida",
        chipInvalidFarm: "Fazenda Inválida",
        chipMissingQuantity: "Quantidade Ausente",
        chipInvalidQuantity: "Quantidade Inválida",
        chipMissingQuality: "Qualidade Ausente",
        chipInvalidQuality: "Qualidade Inválida",
        chipMissingPrice: "Preço Ausente",
        chipInvalidPrice: "Preço Inválido",

      },
    },
    processingBatchBulkImport: {
      bulkImport: "Importar Lotes de Processamento em Massa",
      title: "Importação em Massa de Lotes de Processamento",
      instructions: "Carregue um arquivo CSV ou XLSX usando o modelo abaixo. Cada linha cria um lote de processamento.",
      downloadCsv: "Baixar modelo CSV",
      downloadXlsx: "Baixar modelo XLSX",
      selectFile: "Selecionar arquivo CSV ou XLSX",
      rowsParsed: "{count} linha(s) pronta(s) para importar.",
      import: "Importar",
      imported: "Importados {created} de {total} lote(s).",
      failed: "{failed} linha(s) com falha.",
      rowError: "Linha {row}",
      emptyFile: "O arquivo não possui linhas de dados.",
      missingColumns: "Coluna(s) obrigatória(s) ausente(s): {columns}",
      noBuyingStation: "Nenhuma estação de compra selecionada.",
      validating: "Validando linhas…",
      total: "Total",
      valid: "Válido",
      invalid: "Inválido",
      all: "Todos",
      statusValid: "Válido",
      statusInvalid: "Inválido",
      issues: "Problemas",
      back: "Voltar",
      importValid: "Importar {count} linha(s) válida(s)",
      done: "Concluído",
      rowCol: "Linha",
      startDateCol: "Data de Processamento",
      purchaseOrdersCol: "Códigos de Compra",
      processTypeCol: "Tipo de Processamento",
      gradeCol: "Grau",
      seasonCol: "Temporada",
      statusCol: "Status",
      purchaseDateCol: "Data de Compra",
      processDateCol: "Data de Processamento",
      parchmentCol: "Pergaminho (Kg)",
      bagsCol: "Sacas",
      vehiclePlateCol: "Placa do Veículo",
      harvestedCol: "Colhido",
      pulpedCol: "Despolpado",
      washedCol: "Lavado",
      dryingStartedCol: "Secagem Iniciada",
      movedToStoreCol: "Movido para Armazém",
      templateNote: "Baixe e use os modelos abaixo para importar lotes de processamento em massa.",
      selectTemplate: "Selecionar Modelo",
      templateCsv: "Formato de Importação CSV",
      templateXls: "Formato de Importação XLS",
      downloadCsvFormat: "Baixar Formato CSV",
      downloadXls: "Baixar Formato XLS",
      importingTitle: "Importação em Massa de Lotes de Processamento",
      importingNote: "Seu arquivo carregado está sendo processado.\nNão clique em cancelar, fechar ou atualizar esta página para evitar interrupções.",
      importantNote: "Nota Importante",
      importantNoteDetail: "Use os modelos fornecidos acima para importação em massa de lotes de processamento. Outros formatos resultarão em falha.",
      invalidFileFormat: "Por favor, carregue um arquivo .csv, .xlsx ou .xls válido usando o modelo fornecido.",
      unsupportedFileFormat: "Este formato de arquivo não é suportado.",
      templateErrorIntro: "O arquivo carregado não corresponde ao modelo necessário. Baixe o modelo e tente novamente.",
      importCompleted: "Importação Concluída",
      tabTotalRecords: "Total de Registros",
      tabSuccess: "Sucesso",
      tabIssues: "Problemas",
      filterAll: "Todos",
      filterSuccess: "Sucesso",
      issuesDetected: "Problemas Detectados",
      issuesDetectedHeading: "Problemas Detectados:",
      issuesDetectedDescription: "Algumas linhas têm problemas de dados (ex.: datas ausentes, tipo de processamento desconhecido, valor de pergaminho inválido). Por favor, revise e resolva antes do envio final.",
      deleteRowsWithIssues: "Excluir linhas com problemas",
      editRecord: "Editar registro",
      deleteRecord: "Excluir registro",
      deleteRecordConfirm: "Tem certeza que deseja excluir este registro? Esta ação não pode ser desfeita.",
      deleteDiscrepancyConfirm: "Tem certeza que deseja excluir todas as {count} linha(s) com problemas? Esta ação não pode ser desfeita.",
      cancelImportTitle: "Cancelar Importação",
      cancelImportConfirm: "Tem certeza que deseja cancelar esta importação? Os registros validados não poderão mais ser importados.",
      cancelImportConfirmBtn: "Cancelar Importação",
      importConfirm: "Importar {count} registro(s) válido(s) agora?",
      recordUpdatedSuccess: "Registro atualizado com sucesso.",
      recordsDeletedSuccess: "Registros excluídos com sucesso.",
      importCancelledSuccess: "Importação cancelada com sucesso.",
      genericError: "Ocorreu um erro. Por favor, tente novamente.",
      noDataFound: "Nenhum dado encontrado.",
      editRecordTitle: "Editar Registro",
      submit: "Enviar",
      detailsTitle: "Detalhes do Lote de Processamento",
      close: "Fechar",
      successDialogTitle: "Mensagem de Sucesso",
      importedSuccessfully: "{count} registro(s) de lotes de processamento importado(s) com sucesso.",
      historyFile: "Nome do Arquivo",
      historyImportedOn: "Importado Em",
      historyEmpty: "Nenhum histórico de importação em massa.",
      statusValidating: "Validando",
      statusSuccess: "Importado",
      statusCancelled: "Cancelado",
      errorCodePurchaseDateRequired: "A data de compra é obrigatória.",
      errorCodeInvalidPurchaseDate: "O formato da data de compra não é reconhecido.",
      errorCodeProcessDateRequired: "A data de processamento é obrigatória.",
      errorCodeInvalidProcessDate: "O formato da data de processamento não é reconhecido.",
      errorCodeUnknownProcessType: "O tipo de processamento não é reconhecido.",
      errorCodeNoOrdersForDate: "Nenhum pedido de compra encontrado para a data de compra informada.",
      errorCodeParchmentInvalid: "O valor do pergaminho (Kg) é inválido.",
      errorCodeParchmentExceedsCherry: "O pergaminho (Kg) não pode exceder a quantidade total de cerejas de café.",
      errorCodeInvalidData: "Um ou mais campos contêm dados inválidos.",
      chipPurchaseDateRequired: "Data de Compra Obrigatória",
      chipInvalidPurchaseDate: "Data de Compra Inválida",
      chipProcessDateRequired: "Data de Processamento Obrigatória",
      chipInvalidProcessDate: "Data de Processamento Inválida",
      chipUnknownProcessType: "Tipo de Processamento Desconhecido",
      chipNoOrdersForDate: "Sem Pedidos para esta Data",
      chipParchmentInvalid: "Pergaminho Inválido",
      chipParchmentExceedsCherry: "Pergaminho Excede as Cerejas",
      chipInvalidData: "Dados Inválidos",
    },
    greenCoffee: {
      bulkImport: {
        importButton: "Importar Café Verde em Massa",
        title: "Importação em Massa de Dados de Café Verde",
        breadcrumb: "Visão Geral do Café > Moagem a Seco",
        tabImport: "Importar",
        tabHistory: "Histórico",
        templateNote:
          "Baixe e use os modelos abaixo para importar café verde em massa.",
        selectTemplate: "Selecionar Modelo",
        templateXls: "Importar Formato XLS",
        importingTitle: "Importação em Massa de Dados de Café Verde",
        importingNote:
          "O arquivo enviado está sendo processado no momento.\nNão clique em cancelar, feche ou atualize esta página para evitar interrupções.",
        importCompleted: "Importação Concluída",
        tabTotalRecords: "Total de Registros",
        tabSuccess: "Sucesso",
        tabFailed: "Falhas",
        tabIssues: "Problemas",
        tabDataDiscrepancies: "Discrepâncias de Dados",
        filterAll: "Todos",
        filterSuccess: "Sucesso",
        filterIssues: "Problemas",
        issuesDetectedHeading: "Problemas Detectados:",
        issuesDetectedDescription:
          "Alguns lotes têm problemas de dados (por ex., número de produção inválido, número de produção inexistente no sistema). Revise e resolva-os antes do envio final.",
        deleteLotsWithDataDiscrepancies: "Excluir Lotes com Discrepâncias de Dados",
        lotId: "ID do Lote",
        lotIdAndOutturn: "ID do Lote e Produção",
        grower: "Produtor",
        coffeeType: "Tipo de Café",
        grossAndNetWeight: "Peso Bruto e Peso Líquido",
        issuesDetected: "Problemas Detectados",
        issueOutturnNumberMismatchTitle: "Número de produção incompatível:",
        issueOutturnNumberMismatchDescription:
          "Esta produção não corresponde a nenhum registro de Entrega de Pergaminho existente. Certifique-se de que o Número de Produção foi vinculado manualmente no nível da Fábrica antes de reenviar.",
        issueDuplicateOutturnNumberTitle: "Número de Produção Duplicado:",
        issueDuplicateOutturnNumberDescription:
          "O número de produção aparece várias vezes neste documento enviado.",
        issueMissingOutturnNumberTitle: "Número de Produção Ausente:",
        issueMissingOutturnNumberDescription:
          "A linha enviada não contém um Número de Produção. Um identificador de Produção único e válido é necessário para corresponder o registro ao sistema da fábrica.",
        issueGrowerIdentityMismatchTitle: "Incompatibilidade de Identidade do Produtor:",
        issueGrowerIdentityMismatchDescription:
          "O número de produção está registrado em nosso sistema sob o Produtor {mobileGrowerName}, mas o arquivo enviado o atribui a {xlsGrowerName}. Substituição de dados restrita.",
        issueMissingGrowerCredentialsTitle: "Credenciais do Produtor Ausentes:",
        issueMissingGrowerCredentialsDescription:
          "O registro não possui o Nome do Produtor ou o ID do Produtor. Esses campos de dados são obrigatórios para verificar a propriedade da fábrica antes que o lote possa ser reconciliado.",
        editRecord: "Editar registro",
        deleteRecord: "Excluir registro",
        downloadXls: "Baixar Formato XLS",
        selectFile: "Selecione o arquivo para Carregar os Dados",
        dropHere: "ou arraste e solte aqui",
        importantNote: "Nota Importante",
        importantNoteDetail:
          "Use os modelos fornecidos acima para importar café verde em massa. Outros formatos resultarão em falha.",
        invalidFileFormat: "Carregue um arquivo .xlsx ou .xls válido usando o modelo fornecido.",
        unsupportedFileFormat: "Este formato de arquivo não é suportado.",
        importFailed: "Importação Falhou",
        importFailedIntro:
          "Não foi possível importar o arquivo. Verifique o formato do modelo e os dados das linhas e tente novamente.",
        templateErrorIntro:
          "O arquivo enviado não corresponde ao modelo necessário. Baixe o modelo XLS e tente novamente.",
        tryAgain: "Tentar Novamente",
        errorDetails: "Detalhes",
        historyEmpty: "Ainda não há histórico de importação em massa.",
        // Validation review / import flow
        validationSummaryTitle: "Resumo da Validação",
        recordsReadyToImport: "registros prontos para importar",
        editRecordTitle: "Editar Registro",
        growerCode: "Código do Produtor",
        growerName: "Nome do Produtor",
        greenBeansTotal: "Peso de Entrada Com Sacas (Kg)",
        selectedCount: "selecionado(s)",
        deleteSelected: "Excluir Selecionados",
        deleteRecordConfirm:
          "Tem certeza de que deseja excluir este registro? Esta ação não pode ser desfeita.",
        deleteSelectedConfirm:
          "Tem certeza de que deseja excluir os {count} registro(s) selecionado(s)? Esta ação não pode ser desfeita.",
        deleteDiscrepancyConfirm:
          "Tem certeza de que deseja excluir todos os {count} lote(s) com discrepâncias de dados? Esta ação não pode ser desfeita.",
        cancelImportTitle: "Cancelar Importação",
        cancelImportConfirm:
          "Tem certeza de que deseja cancelar esta importação? Os registros validados não poderão mais ser importados.",
        cancelImportConfirmBtn: "Cancelar Importação",
        importConfirm: "Importar {count} registro(s) válido(s) agora?",
        recordUpdatedSuccess: "Registro atualizado com sucesso.",
        recordsDeletedSuccess: "Registros excluídos com sucesso.",
        importCancelledSuccess: "Importação cancelada com sucesso.",
        importSuccess: "Importação concluída com sucesso.",
        genericError: "Algo deu errado. Tente novamente.",
        // Issue / error-code labels
        issueInvalidDataTitle: "Dados Inválidos:",
        issueInvalidDataDescription:
          "Um ou mais campos contêm dados inválidos. Revise-os e corrija-os.",
        errorCodeOutturnMismatch:
          "Este número de produção não corresponde a nenhum registro de entrega de pergaminho existente.",
        errorCodeOutturnMissing: "O número de produção está ausente.",
        errorCodeOutturnDuplicate:
          "Este número de produção está duplicado no arquivo ou já existe no sistema.",
        errorCodeGrowerMismatch:
          "O nome/código do produtor não corresponde à entrega de pergaminho registrada.",
        errorCodeGrowerMissing: "O nome ou código do produtor está ausente.",
        errorCodeInvalidData: "Um ou mais campos contêm dados inválidos.",
        // History table
        historyFile: "Nome do Arquivo",
        historyImportedOn: "Importado Em",
        historyUploadedBy: "Enviado Por",
        historyCreatedDate: "Data de Criação",
        historyTotalRecords: "Total de Registros",
        historyErrorRecords: "Registros com Erro",
        // Bulk import status labels
        statusValidating: "Validando",
        statusSuccess: "Importado",
        statusCancelled: "Cancelado",
        // Edit record dialog
        editFieldId: "ID",
        inputWeightWithBags: "Peso de Entrada Com Sacas",
        qualityControl: "Controle de Qualidade",
        submit: "Enviar",
        noMillingOutputs: "Nenhum detalhe de saída de moagem.",
        millingCleanCoffee: "Café Limpo (Detalhes de Saída de Moagem)",
        millingBags: "Sacas (Detalhes de Saída de Moagem)",
        millingPockets: "Bolsas (Detalhes de Saída de Moagem)",
        millingWeight: "Peso (Detalhes de Saída de Moagem)",
        millingBulkOutturn: "Produção a Granel (Detalhes de Saída de Moagem)",
        millingRatio: "Proporção (Detalhes de Saída de Moagem)",
        // Detail dialog
        detailsTitle: "Detalhes do Café Verde",
        outturnNo: "N.º de Produção",
        close: "Fechar",
        // Success dialog
        successDialogTitle: "Mensagem de Sucesso",
        importedSuccessfully:
          "{count} registro(s) de café verde foram importados com sucesso.",
        // Filter chip short labels (per error category)
        chipOutturnMismatch: "Número de Produção Incompatível",
        chipOutturnMissing: "Número de Produção Ausente",
        chipOutturnDuplicate: "Número de Produção Duplicado",
        chipGrowerMismatch: "Incompatibilidade de Identidade do Produtor",
        chipGrowerMissing: "Credenciais do Produtor Ausentes",
        chipInvalidData: "Dados Inválidos",
      },
      processGreenCoffee: "Processar Café Verde",
      addedBy: "Adicionado por",
      selectProductType: "Selecionar Tipo de Produto",
      processDate: "Data de Processo",
      selectProcessingBatch: "Selecionar Lote de Processamento",
      lotIdAndDate: "ID do Lote e Data",
      typeAndQuantity: "Tipo e Quantidade",
      supplier: "Fornecedor",
      outturnNumber: "Número de produção",
      totalInputQuantity: "Quantidade Total de Entrada (kg)",
      qualityControl: "Controle de qualidade",
      airHumidity: "Umidade do ar (valor em %)",
      density: "Densidade (kg/cm3)",
      greenCoffeeQualityScore: "Pontuação de Qualidade do Café Verde",
      batchProduction: "Produção do Lote",
      unsortedGreenBeans: "Grãos Verdes Não Classificados (kg)",
      batchProductionDensity: "Densidade de Produção do Lote (kg/cm3)",
      percentagePrimaryDefect: "Percentual de defeito primário",
      percentageSecondaryDefect: "Percentual de defeito secundário",
      greenBeans: "Grãos Verdes",
      totalGreenBeans: "Total de grãos verdes (kg)",
      unitSize: "Tamanho da Unidade (kg)",
      totalBags: "Total de sacas",
      leftoverQuantity: "Quantidade restante",
      leftoverQuantityDesc: "A Quantidade Restante é o valor remanescente que não pode formar uma saca completa. Representa a quantidade que resta após preencher o número máximo de unidades completas do fornecimento total.",
      expiryDate: "Data de validade",
      label: "Etiqueta",
      qualityControlButton: "Controle de qualidade",
      valueInPercent: "valor em %",
      kgCm3: "kg/cm3",
      complete: "Completo",
      lotIdOutturnNo: "ID do Lote / N.º de Produção",
      startDate: "Data de Início",
      greenBeansQualityGrading: "Classificação de Qualidade dos Grãos Verdes",
      totalQuantity: "Quantidade total",
      quantity: "Quantidade",
      packing: "Embalagem",
      bag: "Saca",
      qualityScore: "Pontuação de qualidade",
      noLotsYet: "Nenhum lote ainda. Adicione classificações de qualidade a partir do fluxo de criação.",
      lotId: "ID do Lote",
      percentage: "Percentual",
      createQualityGrade: "Criar Classificação de Qualidade",
      finishGrading: "Concluir Classificação",
      finishGradingDesc: "Uma vez concluído, você não poderá classificar este lote novamente. O desperdício será calculado automaticamente após a conclusão.",
      finishGradingButton: "Concluir Classificação",
      addNewQualityGrade: "Adicionar Nova Classificação de Qualidade",
      totalGreenBeansExceeded: "A quantidade total classificada não pode exceder o total de café verde.",
      lotIdAlreadyExists: "Este ID de lote já está em uso. Use um ID de lote diferente.",
      toAddRecord: "para adicionar um registro.",
      registeredSuccess: "Café verde registrado com sucesso",
      exportNotImplemented: "Exportação não implementada",
      processingBatchRequired: "O lote de processamento é obrigatório",
      outturnAvailable: "O número de produção está disponível",
      outturnExists: "Este número de produção já existe. Por favor, insira um único.",
      totalGreenBeansRequired: "O total de café verde é obrigatório",
      enterHere: "Digite aqui",
      viewTitle: "Classificação de qualidade dos grãos verdes",
      parchmentInformation: "Informação do pergaminho",
      processInformation: "Informação do processo",
      greenBeansInformation: "Informação dos grãos verdes",
      traceabilityLabel: "Etiqueta de rastreabilidade",
      waste: "Desperdício",
      downloadLabel: "Baixar etiqueta",
      startCupping: "Iniciar prova",
      cuppingHistory: "Histórico de prova",
      noDataFound: "Nenhum dado encontrado.",
      noParchmentBatches: "Nenhum lote de pergaminho vinculado.",
      noQualityGrades: "Nenhuma qualidade registrada.",
      batchId: "ID do lote",
      species: "Espécie",
      variety: "Variedade",
      process: "Processo",
      batchRating: "Avaliação do lote",
      humidity: "Umidade",
      totalCoffeeCherryQty: "Quantidade total de cereja",
      weightBeforeProcessing: "Peso antes do processamento",
      numberOfBags: "Número de sacas",
      externalId: "ID externo",
      qrCode: "Código QR",
      latestCuppingScore: "Pontuação de prova mais recente",
      totalWaste: "Desperdício total",
      close: "Fechar",
      unitSizeKgBag: "Tamanho da unidade (kg/saca)",
      grade: "Grau",
      selectGrade: "Selecionar grau",
      quantityRequired: "A quantidade é obrigatória",
      quantityMustBePositive: "A quantidade deve ser maior que 0",
      unitSizeRequired: "O tamanho da unidade é obrigatório",
      unitSizeMustBePositive: "O tamanho da unidade deve ser maior que 0",
      gradeRequired: "O grau é obrigatório",
      labelRequired: "A etiqueta é obrigatória",
      cupping: "Prova",
      cuppingInformation: "Informação da prova",
      cupperName: "Nome do provador",
      cuppingDate: "Data da prova",
      enterCupperName: "Digite o nome do provador",
      attachFiles: "Anexar arquivo(s)",
      selectFilesToUpload: "Selecionar arquivo(s) para carregar os dados",
      orDragAndDrop: "ou arraste e solte aqui",
      lightRoast: "Torra Clara",
      roastingTime: "Tempo de Torra",
      roastingTemperature: "Temperatura de Torra",
      qualities: "Qualidades",
      uniformity: "Uniformidade",
      cleanCup: "Xícara Limpa",
      sweetness: "Doçura",
      overall: "Geral",
      defects: "Defeitos",
      finalScore: "Pontuação Final",
      sessionDetails: "Detalhes da sessão",
      noCuppingHistory: "Nenhum histórico de prova para este café verde.",
      cuppingDataSaved: "Dados da prova salvos.",
      date: "Data",
      roast: "Torra",
      score: "Pontuação",
    },
    confirmDialog: {
      delete: {
        title: "Excluir Estação de Compra",
        message: "Tem certeza de que deseja excluir esta estação de compra?",
        confirmBtn: "Excluir",
      },
      activate: {
        title: "Ativar",
        message: "Tem certeza de que deseja ativar este {entity}?",
        confirmBtn: "Ativar",
      },
      deactivate: {
        title: "Desativar",
        message: "Tem certeza de que deseja desativar este {entity}?",
        confirmBtn: "Desativar",
      },
    },
    
    registerNewFactory: "Registrar Nova Fábrica",
    selectHowYouWantToProceed: "Selecione como deseja prosseguir",
    single: "Único",
    multiple: "Múltiplo",
    user: "Usuário",
    createNewFactory: "Criar uma Nova Fábrica",
    factoryName: "Nome da Fábrica",
    factoryNumber: "Número da Fábrica",
    firstName: "Primeiro Nome",
    lastName: "Sobrenome",
    primaryEmailAddress: "Endereço de E-mail Principal",
    submit: "Enviar",
    downloadTemplate: "Baixar Modelo",
    templateInfo: "Baixe o modelo de arquivo para ver o formato necessário para o registro em massa.",
    templateFormat: "Forneça o arquivo no formato CSV.",
    selectFileToUpload: "Selecione o arquivo para fazer o upload dos dados",
    uploadFileOrDragAndDrop: "ou arraste e solte aqui",
  },
}